import { FlattenMaps } from 'mongoose';

import * as routes from 'api/routes';
import { IModel } from 'models/fake_mandates_slides/interface';

export type Params = any;
export type Result = Array<FlattenMaps<IModel>> | null;

export const WEBSITE_ROUTE = routes.WEBSITE_FAKE_MANDATES_SLIDES_GET_ALL;
